/* eslint-disable */

import React, { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import client from '../../../api/client';
import dayjs from 'dayjs';
import dayTh from 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import BtnGogo from '../../../components/buttongoto/ButtonGoto';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';
import { orderStatus } from '../library';
import { colors } from '../../../helper/constant';
dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

function MyShop_Seller_Deliver(props) {
  const queryClient = useQueryClient();
  const shopId = props.permitdata?.shop_id;

  const [myorder_list, setorder_list] = useState([]);
  const [orderselect, setorderselect] = useState({});
  const [selectedOrders, setSelectedOrders] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [modaltracking, setModaltracking] = useState(false);
  const [modal_load, setmodal_load] = useState({ enable: false, message: '' });
  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const multipartHeaders = {
    Accept: 'application/json',
    'Content-Type': 'multipart/form-data;',
  };

  const invalidateOrderQueries = () => {
    if (shopId) {
      queryClient.invalidateQueries({ queryKey: ['myshop-orders', shopId] });
      queryClient.invalidateQueries({ queryKey: ['order-history', shopId] });
    }
  };

  const postCancelOrder = async (orderId) => {
    const formData = new FormData();
    formData.append('order_id', orderId);
    const response = await client.post('/api/order/myshop/seller/cancelorder', formData, {
      headers: multipartHeaders,
    });
    return response.data;
  };

  const postAcceptOrder = async (orderId) => {
    const formData = new FormData();
    formData.append('order_id', orderId);
    const response = await client.post('/api/order/myshop/seller/acceptorder', formData, {
      headers: multipartHeaders,
    });
    return response.data;
  };

  const postAcceptCustomerCancel = async (orderId) => {
    const formData = new FormData();
    formData.append('order_id', orderId);
    const response = await client.post('/api/order/myshop/seller/acceptcustomercancel', formData, {
      headers: multipartHeaders,
    });
    return response.data;
  };

  const postBookingDeliver = async (order) => {
    const formData = new FormData();
    formData.append('order_id', order.order_id);
    formData.append('courier_code', order.shipping_courier);
    formData.append('shipping_recievename', order.shipping_recievename);
    formData.append('shipping_telno', order.shipping_telno);
    formData.append('shipping_address', order.shipping_address);
    formData.append('shipping_district', order.shipping_district);
    formData.append('shipping_state', order.shipping_state);
    formData.append('shipping_province', order.shipping_province);
    formData.append('shipping_postcode', order.shipping_postcode);
    formData.append('seller_recievename', props.permitdata.shop_name);
    formData.append('seller_telno', props.permitdata.shop_telno);
    formData.append('seller_address', props.permitdata.shop_address);
    formData.append('seller_district', props.permitdata.shop_subdistrict);
    formData.append('seller_state', props.permitdata.shop_district);
    formData.append('seller_province', props.permitdata.shop_province);
    formData.append('seller_postcode', props.permitdata.shop_postcode);
    formData.append('parcel_weight', order.shipping_parcel_weight);
    formData.append('parcel_width', order.shipping_parcel_width);
    formData.append('parcel_length', order.shipping_parcel_length);
    formData.append('parcel_height', order.shipping_parcel_height);

    const response = await client.post('/api/order/myshop/seller/bookingdeliver', formData, {
      headers: multipartHeaders,
    });
    return response.data;
  };

  const cancelOrderMutation = useMutation({
    mutationFn: postCancelOrder,
    onMutate: async () => {
      await sleep(200);
      setmodal_load({ enable: true, message: 'กำลังยกเลิกคำสั่งขาย' });
    },
    onSuccess: (data) => {
      setmodal_load({ enable: false, message: '' });
      if (data.status === 'OK') {
        setModal_popup({
          modaltype: 'modal-success',
          headers: 'สำเร็จ',
          message: data.message,
          enable: true,
        });
      } else {
        setModal_popup({
          modaltype: 'modal-warning',
          headers: 'ขออภัย',
          message: data.message,
          enable: true,
        });
      }
      if (data.reload === true && data.curent_order !== undefined) {
        props.callback_datachanged('shoporder-updatefullstatus', data.curent_order);
      }
      invalidateOrderQueries();
    },
    onError: (err) => {
      setmodal_load({ enable: false, message: '' });
      setModal_popup({
        modaltype: 'modal-error',
        headers: 'ผิดพลาด',
        message: err.message,
        enable: true,
      });
    },
  });

  const acceptOrderMutation = useMutation({
    mutationFn: postAcceptOrder,
    onMutate: async () => {
      await sleep(200);
      setmodal_load({ enable: true, message: 'กำลังตอบรับคำสั่งซื้อ' });
    },
    onSuccess: (data) => {
      setmodal_load({ enable: false, message: '' });
      if (data.status === 'OK') {
        setModal_popup({
          modaltype: 'modal-success',
          headers: 'สำเร็จ',
          message: data.message,
          enable: true,
        });
      } else {
        setModal_popup({
          modaltype: 'modal-warning',
          headers: 'ขออภัย',
          message: data.message,
          enable: true,
        });
      }
      if (data.reload === true && data.curent_order !== undefined) {
        props.callback_datachanged('shoporder-updatefullstatus', data.curent_order);
      }
      invalidateOrderQueries();
    },
    onError: (err) => {
      setmodal_load({ enable: false, message: '' });
      setModal_popup({
        modaltype: 'modal-error',
        headers: 'ผิดพลาด',
        message: err.message,
        enable: true,
      });
    },
  });

  const acceptCustomerCancelMutation = useMutation({
    mutationFn: postAcceptCustomerCancel,
    onMutate: async () => {
      await sleep(200);
      setmodal_load({ enable: true, message: 'กำลังตอบรับคำขอยกเลิก' });
    },
    onSuccess: (data) => {
      setmodal_load({ enable: false, message: '' });
      if (data.status === 'OK') {
        setModal_popup({
          modaltype: 'modal-success',
          headers: 'สำเร็จ',
          message: data.message,
          enable: true,
        });
      } else {
        setModal_popup({
          modaltype: 'modal-error',
          headers: 'Error',
          message: data.message,
          enable: true,
        });
      }
      if (data.reload === true && data.curent_order !== undefined) {
        props.callback_datachanged('shoporder-updatefullstatus', data.curent_order);
      }
      invalidateOrderQueries();
    },
    onError: (err) => {
      setmodal_load({ enable: false, message: '' });
      setModal_popup({
        modaltype: 'modal-error',
        headers: 'ผิดพลาด',
        message: err.message,
        enable: true,
      });
    },
  });

  const bookingDeliverMutation = useMutation({
    mutationFn: postBookingDeliver,
    onMutate: async () => {
      await sleep(200);
      setmodal_load({ enable: true, message: 'กำลังจองระบบขนส่ง' });
    },
    onSuccess: (data) => {
      setModaltracking(false);
      setmodal_load({ enable: false, message: '' });
      if (data.status === 'OK') {
        setModal_popup({
          modaltype: 'modal-success',
          headers: 'สำเร็จ',
          message: data.message,
          enable: true,
        });
      } else {
        setModal_popup({
          modaltype: 'modal-warning',
          headers: 'ขออภัย',
          message: data.message,
          enable: true,
        });
      }
      if (data.reload === true && data.curent_order !== undefined) {
        props.callback_datachanged('shoporder-updatebooking-seller', data.curent_order);
      }
      invalidateOrderQueries();
    },
    onError: (err) => {
      setModaltracking(false);
      setmodal_load({ enable: false, message: '' });
      setModal_popup({
        modaltype: 'modal-error',
        headers: 'ผิดพลาด',
        message: err.message,
        enable: true,
      });
    },
  });

  const [bulkPending, setBulkPending] = useState(false);
  const mutationPending =
    bulkPending ||
    cancelOrderMutation.isPending ||
    acceptOrderMutation.isPending ||
    acceptCustomerCancelMutation.isPending ||
    bookingDeliverMutation.isPending;

  useEffect(() => {
    if (props.data_shoporder_seller_deliver !== undefined) {
      const existingopen = props.data_shoporder_seller_deliver.find((order) => {
        return order.displayitem === true;
      });
      if (existingopen !== undefined) {
        setorder_list(props.data_shoporder_seller_deliver);
      } else {
        const nextshoporderlist = props.data_shoporder_seller_deliver.map((order, index) => {
          if (index === 0) {
            return {
              ...order,
              displayitem: true,
            };
          } else {
            return order;
          }
        });
        setorder_list(nextshoporderlist);
      }
    }
  }, [props.data_shoporder_seller_deliver]);

  function showDialogCallback_General(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function showDialogCallback_Confirm(message) {
    if (mutationPending) return;
    if (message === 'cancel-order') {
      cancelOrderMutation.mutate(orderselect.order_id);
    } else if (message === 'accept-order') {
      acceptOrderMutation.mutate(orderselect.order_id);
    } else if (message === 'accept-cancelorder') {
      acceptCustomerCancelMutation.mutate(orderselect.order_id);
    } else if (message === 'booking') {
      bookingDeliverMutation.mutate(orderselect);
    } else if (message === 'accept-multiple') {
      api_accpet_orders_bulk();
    } else if (message === 'cancel-multiple') {
      api_reject_orders_bulk();
    }
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function getSelectableOrders() {
    return myorder_list.filter(
      (o) => o.order_status === 'IV_Req' || o.order_status === 'PC_Prepare',
    );
  }

  function toggleSelectOrder(order_id) {
    setSelectedOrders((prev) => {
      const next = { ...prev, [order_id]: !prev[order_id] };
      if (!next[order_id]) {
        delete next[order_id];
      }
      const selectables = getSelectableOrders();
      const selectedIds = Object.keys(next).filter((id) => next[id] === true);
      if (selectables.length > 0 && selectedIds.length === selectables.length) {
        setSelectAll(true);
      } else {
        setSelectAll(false);
      }
      return next;
    });
  }

  function toggleSelectAll() {
    const next = !selectAll;
    setSelectAll(next);
    if (next) {
      const all = {};
      const selectables = getSelectableOrders();
      selectables.forEach((o) => {
        all[o.order_id] = true;
      });
      setSelectedOrders(all);
    } else {
      setSelectedOrders({});
    }
  }

  function getSelectedIds() {
    const selectables = getSelectableOrders();
    const selectablesMap = {};
    selectables.forEach((o) => {
      selectablesMap[o.order_id] = true;
    });
    return Object.keys(selectedOrders).filter(
      (id) => selectedOrders[id] === true && selectablesMap[id] === true,
    );
  }

  async function api_accpet_orders_bulk() {
    const ids = getSelectedIds();
    if (ids.length === 0 || mutationPending) return;
    setBulkPending(true);
    setmodal_load({ enable: true, message: `กำลังตอบรับคำสั่งซื้อที่เลือก (0/${ids.length})` });
    await sleep(200);
    const results = [];
    const updatedOrders = [];
    for (let i = 0; i < ids.length; i++) {
      const id = ids[i];
      setmodal_load({
        enable: true,
        message: `กำลังตอบรับคำสั่งซื้อที่เลือก (${i + 1}/${ids.length})`,
      });
      try {
        // eslint-disable-next-line no-await-in-loop
        const data = await postAcceptOrder(id);
        results.push({ id, ok: data.status === 'OK', data });
        if (data.reload === true && data.curent_order !== undefined) {
          updatedOrders.push(data.curent_order);
        }
      } catch (err) {
        results.push({ id, ok: false, err });
      }
    }
    updatedOrders.forEach((order) => {
      props.callback_datachanged('shoporder-updatefullstatus', order);
    });
    invalidateOrderQueries();
    setBulkPending(false);
    setmodal_load({ enable: false, message: '' });
    const successCount = results.filter((r) => r.ok).length;
    setModal_popup({
      modaltype: successCount === ids.length ? 'modal-success' : 'modal-warning',
      headers: 'ผลการทำงาน',
      message: `ตอบรับคำสั่งซื้อเรียบร้อยแล้ว (${successCount}/${ids.length} รายการ)`,
      enable: true,
    });
    setSelectedOrders({});
    setSelectAll(false);
  }

  async function api_reject_orders_bulk() {
    const ids = getSelectedIds();
    if (ids.length === 0 || mutationPending) return;
    setBulkPending(true);
    setmodal_load({ enable: true, message: `กำลังปฏิเสธคำสั่งซื้อที่เลือก (0/${ids.length})` });
    await sleep(200);
    const results = [];
    const updatedOrders = [];
    for (let i = 0; i < ids.length; i++) {
      const id = ids[i];
      setmodal_load({
        enable: true,
        message: `กำลังปฏิเสธคำสั่งซื้อที่เลือก (${i + 1}/${ids.length})`,
      });
      try {
        // eslint-disable-next-line no-await-in-loop
        const data = await postCancelOrder(id);
        results.push({ id, ok: data.status === 'OK', data });
        if (data.reload === true && data.curent_order !== undefined) {
          updatedOrders.push(data.curent_order);
        }
      } catch (err) {
        results.push({ id, ok: false, err });
      }
    }
    updatedOrders.forEach((order) => {
      props.callback_datachanged('shoporder-updatefullstatus', order);
    });
    invalidateOrderQueries();
    setBulkPending(false);
    setmodal_load({ enable: false, message: '' });
    const successCount = results.filter((r) => r.ok).length;
    setModal_popup({
      modaltype: successCount === ids.length ? 'modal-success' : 'modal-warning',
      headers: 'ผลการทำงาน',
      message: `ปฏิเสธคำสั่งซื้อเรียบร้อยแล้ว (${successCount}/${ids.length} รายการ)`,
      enable: true,
    });
    setSelectedOrders({});
    setSelectAll(false);
  }

  function Toggleitem(order_id) {
    const nextshoporderlist = myorder_list.map((order) => {
      if (order.order_id === order_id) {
        return {
          ...order,
          displayitem: !order.displayitem,
        };
      } else {
        return {
          ...order,
          displayitem: false,
        };
      }
    });
    setorder_list(nextshoporderlist);
  }

  return (
    <div className='my-0 font-inter font-th'>
      <div className='row'>
        <div className='col-md-12 mb-2'>
          <div
            className='me-card-body d-flex align-items-center justify-content-start flex-wrap'
            style={{
              border: `1px solid ${colors.borderLight}`,
              borderRadius: 8,
              padding: '10px 14px',
              background: colors.white,
              boxShadow: `0 6px 18px ${colors.shadowBlue}`,
            }}
          >
            <div className='d-flex align-items-center gap-3 w-100 justify-content-between'>
              <div className='d-flex align-items-center gap-2'>
                <label className='custom-checkbox master-checkbox mb-0 d-inline-flex align-items-center cursor-pointer'>
                  <input
                    type='checkbox'
                    checked={selectAll && getSelectableOrders().length > 0}
                    disabled={getSelectableOrders().length === 0}
                    onChange={() => toggleSelectAll()}
                  />
                  <span className='checkmark' />
                  <span style={{ marginLeft: '8px', fontWeight: '500' }}>
                    เลือกทั้งหมด {getSelectableOrders().length > 0 ? `(${getSelectedIds().length}/${getSelectableOrders().length})` : ''}
                  </span>
                </label>
              </div>
              <div className='d-flex gap-2'>
                <button
                  type='button'
                  className='btn-rectan-small btn-success font-th d-flex align-items-center'
                  disabled={getSelectedIds().length === 0 || mutationPending}
                  onClick={() => {
                    if (mutationPending) return;
                    const count = getSelectedIds().length;
                    setModal_popup({
                      modaltype: 'modal-confirm',
                      headers: 'กรุณายืนยัน',
                      message: `ท่านต้องการตอบรับคำสั่งซื้อที่เลือกจำนวน ${count} รายการ ใช่หรือไม่`,
                      enable: true,
                      confirmcode: 'accept-multiple',
                    });
                  }}
                >
                  <i className='fas fa-check-circle mr-1' style={{ fontSize: '13px' }}></i>
                  ตอบรับที่เลือก {getSelectedIds().length > 0 ? `(${getSelectedIds().length})` : ''}
                </button>
                <button
                  type='button'
                  className='btn-rectan-small btn-danger font-th d-flex align-items-center'
                  disabled={getSelectedIds().length === 0 || mutationPending}
                  onClick={() => {
                    if (mutationPending) return;
                    const count = getSelectedIds().length;
                    setModal_popup({
                      modaltype: 'modal-confirm',
                      headers: 'กรุณายืนยัน',
                      message: `ท่านต้องการปฏิเสธคำสั่งซื้อที่เลือกจำนวน ${count} รายการ ใช่หรือไม่`,
                      enable: true,
                      confirmcode: 'cancel-multiple',
                    });
                  }}
                >
                  <i className='fas fa-times-circle mr-1' style={{ fontSize: '13px' }}></i>
                  ปฏิเสธที่เลือก {getSelectedIds().length > 0 ? `(${getSelectedIds().length})` : ''}
                </button>
              </div>
            </div>
          </div>
        </div>
        {myorder_list.length > 0 ? (
          myorder_list.map((order, index0) => (
            <div className='col-md-12 mb-md-2 mb-lg-0' key={order.order_id}>
              <div className='card-mycart mb-2'>
                <div
                  className={
                    'card-mycart-header modern light-theme ' + (selectedOrders[order.order_id] ? 'selected' : '')
                  }
                >
                  <div className='modern-header-responsive'>
                    <div className='d-flex align-items-center gap-3'>
                      {order.order_status === 'IV_Req' || order.order_status === 'PC_Prepare' ? (
                        <div className='d-flex align-items-center' style={{ minWidth: '32px' }}>
                          <label className='custom-checkbox mb-0'>
                            <input
                              type='checkbox'
                              checked={selectedOrders[order.order_id] === true}
                              onChange={() => toggleSelectOrder(order.order_id)}
                            />
                            <span className='checkmark' />
                          </label>
                        </div>
                      ) : null}
                      <div className='bg-white rounded-circle d-flex align-items-center justify-content-center' style={{ width: '40px', height: '40px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)', flexShrink: 0 }}>
                        <i className='font-size-18 fas fa-store text-primary'></i>
                      </div>
                      <div className='d-block'>
                        <div className='card-mycart-title mb-0 font-th'>
                          {order.buyer_shopname}
                        </div>
                        <div className='card-mycart-subtitle font-th'>
                          <i className='fas fa-map-marker-alt mr-1'></i> {order.buyer_shopprovince}
                        </div>
                      </div>
                    </div>
                    <div className='d-flex flex-column align-items-end'>
                      <div className='order-id-label mb-1'>
                        ORD: {order.order_id}
                      </div>
                      {orderStatus(order, 'seller')}
                    </div>
                  </div>
                </div>
              <div className='card-mycart-body'>
                <div className={'' + (order.displayitem ? 'd-block' : 'd-none')}>
                  <div className='d-block d-md-flex justify-content-between pt-0 pb-2 flex-wrap border-bottom'>
                    <div className='d-block'>
                      {order.orderitem !== null
                        ? order.orderitem.map((orderitems, index1) => (
                            <div
                              className={
                                'd-block d-md-flex py-1 ' + (index1 > 0 ? 'border-top' : '')
                              }
                              key={orderitems.orderitem_id}
                            >
                              <div className='d-flex'>
                                <div className='mycart-box-image'>
                                  <img
                                    className='img-fluid max-width-100 p-1 border border-color-1'
                                    src={
                                      `${process.env.REACT_APP_IMAGE_URL}` +
                                      `${orderitems.productitem_id}/` +
                                      `${orderitems.productitem_id}` +
                                      '-1-' +
                                      orderitems.img1_key +
                                      '.jpg'
                                    }
                                    alt='Image Description'
                                  />
                                </div>
                                <div className='d-block product-detail'>
                                  <div className='mycart-box-productname py-0'>
                                    {orderitems.productitem_name}
                                  </div>
                                  <div className='mycart-box-productinter py-0'>
                                    {orderitems.productitem_inter}
                                  </div>
                                </div>
                              </div>
                              <div className='mycart-box-pricelist'>
                                <table>
                                  <tbody className='d-block mt-0'>
                                    {orderitems.orderitem_pricelist !== null
                                      ? orderitems.orderitem_pricelist.map((pricelist, index1) => (
                                          <tr
                                            className='mycart-table-pricelist-row py-0'
                                            key={pricelist.pricelist_id}
                                            style={{ paddingTop: '0px' }}
                                          >
                                            <td className='product-unit'>
                                              ชุด {pricelist.unit} ชิ้น
                                            </td>
                                            <td className='product-stock'>
                                              Exp.{' '}
                                              {dayjs(new Date(pricelist.expire)).format(
                                                'DD MMM BBBB',
                                              )}
                                            </td>
                                            <td className='product-quantity'>
                                              x {pricelist.select} ชุด
                                            </td>
                                            <td className='product-subtotal'>
                                              ฿{' '}
                                              {pricelist.subtotal.toLocaleString(undefined, {
                                                maximumFractionDigits: 0,
                                                minimumFractionDigits: 0,
                                              })}
                                            </td>
                                          </tr>
                                        ))
                                      : null}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          ))
                        : null}
                    </div>
                    <div className='d-block mt-2 mb-5 mb-md-2' style={{ minWidth: '250px' }}>
                      <div className='d-flex justify-content-between py-0'>
                        <div className='table-summary-cell'>มูลค่าสินค้า</div>
                        <div className='table-summary-cellt'>
                          ฿{' '}
                          {Number(order.shop_subtotal).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          })}
                        </div>
                      </div>
                      <div className='d-flex justify-content-between py-0'>
                        <div className='table-summary-cell'>ค่าขนส่ง</div>
                        <div className='table-summary-cell aligh-right'>
                          ฿{' '}
                          {Number(order.shop_shipping_markup).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          })}
                        </div>
                      </div>
                      {parseFloat(order.summary_discount) > 0 ? (
                        <div className='d-flex justify-content-between py-0'>
                          <div className='table-summary-cell text-danger'>ส่วนลด</div>
                          <div className='table-summary-cell aligh-right text-danger'>
                            - ฿{' '}
                            {Number(order.summary_discount).toLocaleString(undefined, {
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                      ) : null}
                      {order.coupon_id ? (
                        <div className='d-flex justify-content-between py-0'>
                          <div className='table-summary-cell text-muted' style={{ fontSize: '11px' }}>
                            โค้ดส่วนลด
                          </div>
                          <div className='table-summary-cell aligh-right text-muted' style={{ fontSize: '11px' }}>
                            🏷️ {order.coupon_id}
                          </div>
                        </div>
                      ) : null}
                      <div className='d-flex justify-content-between py-0 border-bottom'>
                        <div className='table-summary-cell'>ยอดรวม</div>
                        <div className='table-summary-cell aligh-right'>
                          ฿{' '}
                          {Number(order.summary_net || order.shop_total).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          })}
                        </div>
                      </div>
                      <div className='d-flex justify-content-between py-0 mt-2'>
                        <div className='table-summary-cell'>ค่าธรรมเนียม</div>
                        <div className='table-summary-cell aligh-right'>
                          ฿{' '}
                          {Number(order.shop_servicecharge).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          })}
                        </div>
                      </div>
                      <div className='d-flex justify-content-between py-0 border-bottom text-success'>
                        <div className='table-summary-cell'>ยอดของร้าน</div>
                        <div className='table-summary-cell aligh-right'>
                          ฿{' '}
                          {Number(order.shop_income).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          })}
                        </div>
                      </div>
                      {/* <div className='d-flex justify-content-between py-0 mt-3'>
                        <div className='table-summary-cell'>พัสดุ</div>
                        <div className='table-summary-cell aligh-right'>
                          {order.shipping_parcel_name}
                        </div>
                      </div> */}
                      <div className='d-flex justify-content-between py-0 border-bottom'>
                        <div className='table-summary-cell'>ขนส่งโดย</div>
                        <div className='table-summary-cell aligh-right'>
                          {order.courier_fullname}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='d-block text-success mt-1'>ที่อยู่ในการจัดส่ง</div>
                  <table>
                    <tbody className='d-block mt-0'>
                      <tr className=''>
                        <td width={'160px'} className='mt-0 mb-0'>
                          ผู้รับ
                        </td>
                        <td className='mt-0 mb-0'>{order.shipping_recievename}</td>
                      </tr>
                      <tr className=''>
                        <td className='mt-0 mb-0'>เบอร์โทรศัพท์</td>
                        <td className='mt-0 mb-0'>{order.shipping_telno}</td>
                      </tr>
                      <tr className=''>
                        <td className='mt-0 mb-0'>ที่อยู่ในการจัดส่ง</td>
                        <td className='mt-0 mb-0'>
                          {order.shipping_address} {order.shipping_district} {order.shipping_state}{' '}
                          {order.shipping_province} {order.shipping_postcode}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div className='d-flex justify-content-between gap-2 mt-4 '>
                    <div className='d-flex gap-2'>
                      {order.order_status === 'IV_Req' && order.api_paymentstatus === 'Success' ? (
                        <button
                          type='button'
                          className='btn-rectan-small btn-danger font-th'
                          disabled={mutationPending}
                          onClick={() => {
                            if (mutationPending) return;
                            setorderselect(order);
                            setModal_popup({
                              modaltype: 'modal-confirm',
                              headers: 'กรุณายืนยัน',
                              message:
                                'ท่านต้องการปฏิเสธคำสั่งซื้อ ใช่หรือไม่ หากใช่ กรุณากดปุ่ม "ดำเนินการต่อ"',
                              enable: true,
                              confirmcode: 'cancel-order',
                            });
                          }}
                        >
                          ปฏิเสธคำสั่งซื้อ
                        </button>
                      ) : null}
                      {order.order_status === 'PC_Prepare' ? (
                        <button
                          type='button'
                          className='btn-rectan-small btn-danger font-th'
                          disabled={mutationPending}
                          onClick={() => {
                            if (mutationPending) return;
                            setorderselect(order);
                            setModal_popup({
                              modaltype: 'modal-confirm',
                              headers: 'กรุณายืนยัน',
                              message:
                                'ท่านยกเลิกคำสั่งขาย ใช่หรือไม่ หากใช่ กรุณากดปุ่ม "ดำเนินการต่อ"',
                              enable: true,
                              confirmcode: 'cancel-order',
                            });
                          }}
                        >
                          ยกเลิกคำสั่งขาย
                        </button>
                      ) : null}

                      {order.order_status === 'IV_Req' && order.api_paymentstatus === 'Success' ? (
                        <button
                          type='button'
                          className='btn-rectan-small btn-success font-th'
                          disabled={mutationPending}
                          onClick={() => {
                            if (mutationPending) return;
                            setorderselect(order);
                            setModal_popup({
                              modaltype: 'modal-confirm',
                              headers: 'กรุณายืนยัน',
                              message:
                                'ท่านตอบรับตอบรับคำสั่งซื้อ ใช่หรือไม่ หากใช่ กรุณากดปุ่ม "ดำเนินการต่อ"',
                              enable: true,
                              confirmcode: 'accept-order',
                            });
                          }}
                        >
                          ตอบรับคำสั่งซื้อ
                        </button>
                      ) : null}

                      {order.order_status === 'PC_C_Cancel_Req' ? (
                        <button
                          type='button'
                          className='btn-rectan-small btn-warning font-th'
                          disabled={mutationPending}
                          onClick={() => {
                            if (mutationPending) return;
                            setorderselect(order);
                            setModal_popup({
                              modaltype: 'modal-confirm',
                              headers: 'กรุณายืนยัน',
                              message:
                                'ท่านตอบรับคำขอยกเลิกคำสั่งซื้อ ใช่หรือไม่ หากใช่ กรุณากดปุ่ม "ดำเนินการต่อ"',
                              enable: true,
                              confirmcode: 'accept-cancelorder',
                            });
                          }}
                        >
                          ตอบรับคำขอยกเลิก
                        </button>
                      ) : null}

                      {order.order_status === 'PC_Prepare' ? (
                        <button
                          type='button'
                          className='btn-rectan-small btn-primary text-white font-th'
                          disabled={mutationPending}
                          onClick={() => {
                            if (mutationPending) return;
                            setorderselect(order);
                            setModaltracking(true);
                          }}
                        >
                          จองระบบขนส่ง
                        </button>
                      ) : null}
                    </div>
                    <div
                      className='ml-1 mouse-pointer'
                      onClick={() => {
                        Toggleitem(order.order_id);
                      }}
                    >
                      <i className='fas fa-chevron-up py-0 font-size-12'></i> ย่อรายละเอียด
                    </div>
                  </div>
                </div>
                <div className={'' + (order.displayitem === false ? 'd-block' : 'd-none')}>
                  <div className='d-flex justify-content-between'>
                    <div className='d-block mt-0'>
                      <div className='table-summary-cell ml-1'>
                        สินค้าจำนวน {order.orderitem !== null ? order.orderitem.length : null}{' '}
                        รายการ
                      </div>
                      <p className='table-summary-cell ml-1 py-0 mb-0'>
                        วันที่สั่งซื้อ{' '}
                        {dayjs(new Date(order.createtime))
                          .subtract(7, 'hours')
                          .format('DD MMM BBBB HH:mm')}
                      </p>
                    </div>
                    <div className='d-block mt-0'>
                      <div
                        className='ml-1 mouse-pointer'
                        onClick={() => {
                          Toggleitem(order.order_id);
                        }}
                      >
                        <i className='fas fa-chevron-down py-0 font-size-12'></i> แสดงรายละเอียด
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
          <div className='col-md-12'>
            <div className='empty-state-container'>
              <div className='empty-state-icon'>
                <i className='fas fa-box-open'></i>
              </div>
              <div className='empty-state-title font-th'>ไม่มีรายการจัดส่ง</div>
              <div className='empty-state-text font-th'>ยังไม่พบออเดอร์ที่ต้องดำเนินการจัดส่งในขณะนี้</div>
            </div>
          </div>
        )}
      </div>

      <div
        className='modal-deliver-booking font-th'
        style={{ display: modaltracking ? 'block' : 'none' }}
      >
        <div className='modal-deliver-booking-wrapper'>
          <form id='form-delivery'>
            <div className='row'>
              <div className='col-md-12'>
                <div className='form-group'>
                  <h6 className=''>ระบบจองการขนส่งสินค้า</h6>
                  <div className='editname pr-5 text-success'>ชื่อที่อยู่ผู้ส่ง</div>
                  <div className='editname pr-5'>รายละเอียด</div>
                  <div className='text-grey-11 pr-5'>
                    {props.permitdata.shop_name} {props.permitdata.shop_telno}
                  </div>
                  <div className='text-grey-11 pr-5'>
                    {props.permitdata.shop_address} {props.permitdata.shop_subdistrict}{' '}
                    {props.permitdata.shop_district} {props.permitdata.shop_province}{' '}
                    {props.permitdata.shop_postcode}
                  </div>

                  <div className='editname pr-5  mt-5 text-success'>ชื่อที่อยู่ผู้รับ</div>
                  <div className='editname pr-5'>รายละเอียด</div>
                  <div className='text-grey-11 pr-5'>
                    {orderselect.shipping_recievename} {orderselect.shipping_telno}
                  </div>
                  <div className='text-grey-11 pr-5'>
                    {orderselect.shipping_address} {orderselect.shipping_district}{' '}
                    {orderselect.shipping_state} {orderselect.shipping_province}{' '}
                    {orderselect.shipping_postcode}
                  </div>

                  <div className='editname pr-5  mt-5 text-success'>
                    บริษัทขนส่งและขนาดกล่องพัสดุ
                  </div>
                  <div className='text-grey-11 pr-5'>{orderselect.courier_fullname}</div>
                  <div className='text-grey-11 pr-5'>{orderselect.shipping_parcel_name}</div>

                  <div className='d-flex justify-content-end mt-5'>
                    <button
                      className='btn btn-warning btn-sm  font-th modal-forceclose'
                      type='button'
                      disabled={mutationPending}
                      onClick={() => {
                        if (mutationPending) return;
                        setModal_popup({
                          modaltype: 'modal-confirm',
                          headers: 'กรุณายืนยัน',
                          message:
                            'ท่านต้องการจองบริษัทขนส่ง ใช่หรือไม่ หากใช่ กรุณากดปุ่ม "ดำเนินการต่อ"',
                          enable: true,
                          confirmcode: 'booking',
                        });
                      }}
                    >
                      <i className='fe-save'></i> ยืนยันการจอง
                    </button>
                    <button
                      className='btn btn-light btn-sm  font-th modal-forceclose'
                      type='button'
                      onClick={() => {
                        setorderselect({});
                        setModaltracking(false);
                      }}
                    >
                      <i className='fe-x'></i> ยกเลิก
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <ModalLoad option={modal_load}></ModalLoad>
      <ModalPopupMessage
        callback_general={(message) => {
          showDialogCallback_General(message);
        }}
        callback_confirm={(message) => {
          showDialogCallback_Confirm(message);
        }}
        options={modal_popup}
      />
      {modaltracking ? <div className='meya-backdrop'></div> : null}
      <BtnGogo></BtnGogo>
    </div>
  );
}

export default MyShop_Seller_Deliver;
